import instance from './Request'

export default {
  postLogin: async (config) => instance.post(
    'api/auth/login',
    config
  ).catch(function (error) {
    if (error.response) {
      return error.response
    }
  }),
  postLoginAzure: async (config) => instance.post(
    'api/auth/login/azure',
    config
  ).catch(function (error) {
    if (error.response) {
      return error.response
    }
  }),
  postAccount: async (config) => instance.post(
    'api/auth',
    config
  ).catch(function (error) {
    if (error.response) {
      return error.response
    }
  }),
  getCompanyName: async (idCompanies) => instance.get(
    `api/master-data/contractors?companyId=${idCompanies}`
  ),
  getCompanyLocation: async (idCompanies) => instance.get(
    `api/master-data/work-locations?companyId=${idCompanies}`
  ),
  getWorkUnit: async () => instance.get(
    'api/master-data/work-units'
  ),
  postHrisAccount: async (form) => instance.post(
    'api/auth/register-incomplete-account',
    form
  ),
  masterData: {
    companies: params => instance.get('/api/master-data/companies', { params }),
    contractors: params => instance.get('/api/master-data/contractors', { params }),
    workLocations: params => instance.get('/api/master-data/work-locations', { params }),
    workStatuses: params => instance.get('/api/master-data/work-statuses', { params }),
    workLocationsExist: params => instance.get('/api/master-data/work-locations/exist', { params }),
    customCompanies: params => instance.get('/api/master-data/companies/custom', { params }),
    customContractors: params => instance.get('/api/master-data/contractors/custom', { params }),
    customWorkLocations: params => instance.get('/api/master-data/work-locations/custom', { params }),
    role: params => instance.get('/api/master-data/roles', { params }),
    permissions: params => instance.get('/api/master-data/permissions', { params })
  },
  auth: {
    registerCheck: (body) => instance.post('/api/auth/register-check', body).catch(function (error) {
      return error.response
    }),
    register: (body) => instance.post('/api/auth/register', body).catch(function (error) {
      return error.response
    }),
    verifyOtpMfa: (body) => instance.post('/api/auth/otp-verify', body).catch(function (error) {
      return error.response
    }),
    resendOtpMfa: (body) => instance.post('/api/auth/otp-resend', body).catch(function (error) {
      return error.response
    })
  },
  surveys: {
    get: (id, params) => instance.get(`api/surveys/${id}`, { params }),
    saveResponses: (id, form) => instance.post(`/api/surveys/${id}/responses`, form).catch(function (error) {
      return error.response
    }),
    editResponses: (id, form, responseId) => instance.put(`/api/surveys/${id}/responses/${responseId}`, form).catch(function (error) {
      return error.response
    }),
    exportResponses: (id, params) => instance.get(`/api/surveys/${id}/responses/excel`, { responseType: 'blob', params }),
    listResponses: (id, params) => instance.get(`/api/surveys/${id}/responses`, { params }),
    getResponsesId: (id, responseId) => instance.get(`/api/surveys/${id}/responses/${responseId}`),
    updateStatus: (id, responseId, status) => instance.put(`/api/surveys/${id}/responses/${responseId}/status`, status).catch(function (error) {
      return error.response
    })
  },
  users: {
    me: () => instance.get('api/users/me'),
    list: params => instance.get('api/users', { params }),
    get: id => instance.get(`api/users/${id}`),
    put: (id, body) => instance.put(`/api/users/${id}`, body).catch(function (error) {
      return error.response
    }),
    delete: (id) => instance.delete(`/api/users/${id}`),
    putPassword: (id, body) => instance.put(`/api/users/${id}/password`, body),
    updateStatus: (id, body) => instance.put(`/api/users/${id}/status`, body)
  },
  roles: {
    list: params => instance.get('/api/roles', { params }),
    save: body => instance.post('/api/roles', body),
    update: (id, body) => instance.put(`/api/roles/${id}`, body),
    delete: id => instance.delete(`/api/roles/${id}`)
  },
  dashboard: {
    summary: (query = '') => instance.get(`/api/dashboard/summary?${query}`),
    summaryUnsubmittedDetail: (query = '') => instance.get(`/api/dashboard/summary/unsubmitted-detail?${query}`),
    lineChart: (query = '') => instance.get(`/api/dashboard/line-chart?${query}`),
    fitUnfitRateComparison: (query = '') => instance.get(`/api/dashboard/fit-unfit-rate-comparison?${query}`),
    averageSubmitter: (query = '') => instance.get(`/api/dashboard/average-submitter?${query}`),
    submissionDepartment: (query = '') => instance.get(`/api/dashboard/total-submission-by-department?${query}`),
    riskLevel: (query = '') => instance.get(`/api/dashboard/total-risk-level?${query}`),
    testResult: (query = '') => instance.get(`/api/dashboard/test-result?${query}`),
    case: (query = '') => instance.get(`/api/dashboard/total-symptomps-case?${query}`),
    averageContractor: (query = '') => instance.get(`/api/dashboard/average-contractor?${query}`),
    totalCase: (query = '') => instance.get(`/api/dashboard/total-case?${query}`)
  },
  companies: {
    list: params => instance.get('/api/companies', { params }),
    custom: params => instance.get('/api/companies/custom', { params }),
    add: body => instance.post('/api/companies', body),
    get: id => instance.get(`/api/companies/${id}`),
    delete: id => instance.delete(`api/companies/${id}`),
    update: (id, body) => instance.put(`api/companies/${id}`, body),
    getInformation: (id, workLocationId) => instance.get(`/api/companies/${id}/contact-persons/${workLocationId}`),
    updateInformation: (id, workLocationId, body) => instance.put(`/api/companies/${id}/contact-persons/${workLocationId}`, body),
    deleteInformation: (id, workLocationId) => instance.delete(`/api/companies/${id}/contact-persons/${workLocationId}`)
  },
  workLocations: {
    list: params => instance.get('/api/work-locations', { params }),
    save: body => instance.post('/api/work-locations', body),
    update: (id, body) => instance.put(`/api/work-locations/${id}`, body),
    delete: id => instance.delete(`/api/work-locations/${id}`),
    listActual: params => instance.get('/api/work-locations/actual', { params })
  },
  workStatuses: {
    list: params => instance.get('/api/work-statuses', { params }),
    save: body => instance.post('/api/work-statuses', body),
    update: (id, body) => instance.put(`/api/work-statuses/${id}`, body),
    delete: id => instance.delete(`/api/work-statuses/${id}`)
  },
  workUnits: {
    list: params => instance.get('/api/work-units', { params })
  },
  contractors: {
    list: params => instance.get('/api/contractors', { params })
  },
  question: {
    list: params => instance.get('/api/questions', { params }),
    add: body => instance.post('/api/questions', body),
    get: id => instance.get(`/api/questions/${id}`),
    update: (id, body) => instance.put(`/api/questions/${id}`, body),
    delete: id => instance.delete(`/api/questions/${id}`)
  },
  notifications: {
    list: params => instance.get('/api/notifications', { params }),
    save: body => instance.post('/api/notifications', body),
    update: (id, body) => instance.put(`/api/notifications/${id}`, body),
    delete: id => instance.delete(`/api/notifications/${id}`)
  },
  criteria: {
    list: params => instance.get('api/criterias', { params }),
    get: id => instance.get(`/api/criterias/${id}`),
    update: (id, body) => instance.put(`/api/criterias/${id}`, body),
    add: body => instance.post('/api/criterias', body),
    delete: id => instance.delete(`/api/criterias/${id}`)
  }
}
